<template>
	<div class="list-inventory-template-detail-component">
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control mr-sm-2 form-control-sm" type="search" placeholder="Buscar articulo" aria-label="Buscar" :disabled="searchingInventoryTemplateDetail" v-on:keyup.enter="getAllInventoryTemplateDetailForInventoryIdLocal(1)" v-model="searchInventoryTemplateDetail">
				<button class="btn btn-primary my-2 my-sm-0 btn-sm" @click="getAllInventoryTemplateDetailForInventoryIdLocal(1)" :disabled="searchingInventoryTemplateDetail">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
				<div class="form-group form-check" :disabled="searchingInventoryTemplateDetail">
					<input type="checkbox" class="form-check-input" id="exampleCheck1" :disabled="searchingInventoryTemplateDetail" v-model="onlyDifference" @change="getAllInventoryTemplateDetailForInventoryIdLocal(1)">
					<label class="form-check-label" for="exampleCheck1">Solo con diferencias</label>
				</div>
				<div class="form-group form-check ml-2">
					<input type="checkbox" class="form-check-input" id="exampleCheck1" :disabled="searchingInventoryTemplateDetail" v-model="unconfirmed" @change="getAllInventoryTemplateDetailForInventoryIdLocal(1)">
					<label class="form-check-label" for="exampleCheck1">Sin Confirmar</label>
				</div>
			</div>
			<div class="form-inline">
				<button class="btn btn-warning my-2 my-sm-0 btn-sm" @click="updateStoreRackModuleWithInventoryLocal" v-show="!disabled">Actualizar Racks</button>
			</div>
		</nav>
		<table class="table table-sm table-12 table-hover">
			<thead>
				<tr>
					<th>#</th>
					<th>Articulo</th>
					<th>Planilla</th>
					<th>Hubicación</th>
					<th class="text-center">Conteo 1</th>
					<th class="text-center">Conteo 2</th>
					<th class="text-center">Conteo 3</th>
					<th class="text-center">Conteo 4</th>
					<th class="text-center">Definitivo</th>
					<th class="text-center"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-if="searchingInventoryTemplateDetail">
					<td colspan="10" class="text-center">Buscando Detalles . . .</td>
				</tr>
				<tr v-for="(item, index) in listInventoryTemplateDetailFilter" :key="index">
					<td class="align-middle" :class="(item.withDifferences) ? 'border-bottom border-warning' :''">{{ item.id }}</td>
					<td class="align-middle" :class="(item.withDifferences) ? 'border-bottom border-warning' :''">
						<p>{{ item.product.name }}</p>
						<small>Cod: {{ item.product.id }} | ISBN: {{ item.product.isbn }}</small>
					</td>
					<td class="align-middle" :class="(item.withDifferences) ? 'border-bottom border-warning' :''"><router-link :to="'/inventoryTemplate/' + item.inventory_template_id" target="_blank">{{ getNameInventoryTemplateFromDetail(item) }}</router-link></td>
					<td class="align-middle" :class="(item.withDifferences) ? 'border-bottom border-warning' :''"><span @click="showSideComponent(item)" class="pointer">{{ getLocationInventoryTemplateFromDetail(item) }}</span></td>
					<td class="align-middle text-center" :class="(item.withDifferences) ? 'border-bottom border-warning' :''" :title="'Actualizado el ' + item.updated_at_1">
						<span :class="(item.updated_at_1 == null) ? 'text-secondary' : ''">{{ item.count_1 }}</span>
					</td>
					<td class="align-middle text-center" :class="(item.withDifferences) ? 'border-bottom border-warning' :''" :title="'Actualizado el ' + item.updated_at_2">
						<span :class="(item.updated_at_2 == null) ? 'text-secondary' : ''">{{ item.count_2 }}</span>
					</td>
					<td class="align-middle text-center" :class="(item.withDifferences) ? 'border-bottom border-warning' :''" :title="'Actualizado el ' + item.updated_at_3">
						<span :class="(item.updated_at_3 == null) ? 'text-secondary' : ''">{{ item.count_3 }}</span>
					</td>
					<td class="align-middle text-center" :class="(item.withDifferences) ? 'border-bottom border-warning' :''" :title="'Actualizado el ' + item.updated_at_4">
						<span :class="(item.updated_at_4 == null) ? 'text-secondary' : ''">{{ item.count_4 }}</span>
					</td>
					<td class="align-middle text-center" :class="(item.withDifferences) ? 'border-bottom border-warning' :''">
						<input class="input-default text-center"
							v-model="item.count_end"
							:readonly="updatingInventoryTemplateDetail"
							:title="'Actualizado el ' + item.updated_at_end"
							@focus="$event.target.select()"
							@keyup.enter="updateCount('end', item)">
					</td>
					<td class="align-middle text-right" :class="(item.withDifferences) ? 'border-bottom border-warning' :''">
						<i class="fas fa-check text-success" v-if="!item.withDifferences"></i>
						<i class="fas fa-exclamation-triangle text-warning" v-else></i>
					</td>
				</tr>
			</tbody>
		</table>
		<pagination :pagination="paginationInventoryTemplateDetail" @getAllList="getAllInventoryTemplateDetailForInventoryIdLocal"></pagination>

		<!-- Button trigger modal -->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" ref="btnShowSideComponentComponentModal" v-show="false">
			Asignar Planilla
		</button>

		<!-- Modal -->
		<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<side-component
											ref="sideComponent"
											:id="storeRackSideId"
											:storeRackSideRowColumnIds="storeRackSideRowColumnIds">
										</side-component>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" ref="btnCloseAssignInventoryTemplateEmployeeModal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import inventoryTemplateDetail from '@/mixins/inventories/inventoryTemplateDetail.js'
	import Pagination from '@/components/Pagination.vue'

	import SideComponent from '@/components/SideComponent.vue'

	export default {
		name: 'ListInventoryTemplateDetailComponent',
		mixins: [axiosAction, errors, mixin, inventoryTemplateDetail],
		props: ['inventoryId', 'disabled'],
		data() {
			return {
				search: '',
				storeRackSideId: 0,
				storeRackSideRowColumnIds: []
			}
		},
		components: {
			'pagination': Pagination,
			'side-component': SideComponent,
		},
		computed: {
			listInventoryTemplateDetailFilter() {
				let list = []
				list = this.listInventoryTemplateDetail.filter(e => {
							let differences = false
							let count = []
							e.count_1 = (isNaN(parseInt(e.count_1))) ? 0 : parseInt(e.count_1)
							e.count_2 = (isNaN(parseInt(e.count_2))) ? 0 : parseInt(e.count_2)
							e.count_3 = (isNaN(parseInt(e.count_3))) ? 0 : parseInt(e.count_3)
							e.count_4 = (isNaN(parseInt(e.count_4))) ? 0 : parseInt(e.count_4)
							e.count_end = (isNaN(parseInt(e.count_end))) ? 0 : parseInt(e.count_end)
							if(e.count_1 != '') {
								count.push(e.count_1)
							}
							if(e.count_2 != '') {
								count.push(e.count_2)
							}
							if(e.count_3 != '') {
								count.push(e.count_3)
							}
							if(e.count_4 != '') {
								count.push(e.count_4)
							}
							for(let i=1; i < count.length; i++) {
								if(count[i - 1] != count[i])
									differences = true						
							}
							e.withDifferences = differences
							return true
						})
				return list
			},
		},
		methods: {
			initComponentLocal() {
			},
			getAllInventoryTemplateDetailForInventoryIdLocal(page = 1) {
				this.getAllInventoryTemplateDetailForInventoryId(this.inventoryId, page)
			},
			getAllInventoryTemplateDetailResultLocal(response) {},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllInventoryTemplateDetailResult': this.getAllInventoryTemplateDetailResult(response); break;
					case 'updateInventoryTemplateDetailResult': this.updateInventoryTemplateDetailResult(response); break;
					case 'updateStoreRackModuleWithInventoryResult': this.updateStoreRackModuleWithInventoryResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			showSideComponent(item) {
				this.storeRackSideId = item.store_rack_side_row_column.store_rack_side_id
				this.storeRackSideRowColumnIds = [item.store_rack_side_row_column_id]
				
				this.$refs.btnShowSideComponentComponentModal.click()
				setTimeout(() => {  this.$refs.sideComponent.$refs.btnGetStoreRackSide.click() }, 100)
			},
			updateInventoryTemplateDetailResultLocal(response) {
				if(response.data.success == true && response.data.message == true) {
					this.$snotify.success('Cantidad actualizada', 'Listo!!!');
				} else {
				}				
			},
			updateStoreRackModuleWithInventoryLocal() {
				if(confirm('ALERTA!!!\nSe cambiaran los datos actuales de los RACK con los datos del inventario\n¿Deseas continuar?')) {
					this.updateStoreRackModuleWithInventory(this.inventoryId)
				}
			},
			updateStoreRackModuleWithInventoryResultLocal(response) {
				if(response.data.success == true) {

				} else {
					
				}
			}
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
